import {Injectable, NgZone, ViewEncapsulation} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import 'jquery';
import {ConfigService} from './config.service';
import {TokenService} from "./token.service";
import {Observable} from 'rxjs';


@Injectable(
  {
    providedIn: 'root'
  }
)
export class TicketingService {
  url: string = this.configService.apiTicketingUrl;
  encapsulation: ViewEncapsulation.None;
  token: string

  constructor(public http: HttpClient, private ngZone: NgZone, private router: Router, private configService: ConfigService,
              private tokenService: TokenService,
  ) {
  }

  searchOrganizers(search: string, partnerId?: string) {
    return new Observable(observer => {
      this.tokenService.waitForTokenApiTicketing(10000)
        .then(() => {
          const params = new URLSearchParams();
          params.set('search', search);
          if (partnerId) {
            params.set('partnerId', partnerId);
          }
          this.http.get<any>(`${this.configService.apiTicketingUrl}/api/organizers?${params.toString()}`, {
            headers: {
              Authorization: this.tokenService.tokenApiTicketing
            }
          }).subscribe({
            next: (data) => observer.next(data),
            error: (err) => observer.error(err),
            complete: () => observer.complete()
          });
        })
        .catch(err => observer.error(err));
    });
  }

  recreateParticipant(idEvent, idTplTicket, idParticipant) {
    return new Promise((resolve, reject) => {
      this.tokenService.waitForTokenApiTicketing(10000)
        .then(() => {
          this.http.get(this.url + '/sbw-events-v2/recreateParticipant', {
            headers: {
              Authorization: this.tokenService.tokenApiTicketing,
              idevent: idEvent,
              idtemplate: idTplTicket,
              idticket: idParticipant,
            }
          }).toPromise()
            .then(data => resolve(data))
            .catch(err => reject(err));
        })
        .catch(err => reject(err));
    });
  }

}
